export default {
  pageTitle: '管理限时折扣商品',
  region: '国别',
  radio1: '所有',
  radio2: '进行中',
  radio3: '待审核',
  radio4: '已被拒',
  radio5: '已过期',
  timeLimit: '有效期',
  radio6: '1天',
  radio7: '2天',
  radio8: '3天',
  radio9: '5天',
  radio10: '7天',
  radio15: '15天',
  radio30: '30天',
  applyTime: '申请时间',
  placeholder1: 'Listing#',
  placeholder2: 'SKU#',
  btn1: '批量操作',
  btn2: '批量下架',
  btn3: '批量再报',
  // -----------------
  auditStatus1: '待审核',
  auditStatus2: '未通过',
  auditStatus3: '进行中',
  auditStatus4: '已失效',
  columns1: 'Listing ID',
  columns2: 'SKU#',
  columns3: 'SKU标题',
  columns4: '销售价',
  columns5: '促销价',
  columns6: '申请时间',
  columns7: '审核时间',
  columns8: '有效期',
  columns9: '过期日期',
  columns10: '状态',
  columns11: '操作',
  renderBtn1: '编辑',
  renderBtn2: '取消',
  renderBtn3: '下架',
  renderBtn4: '再报',
  confirmTitle1: '确定取消操作吗？',
  confirmTitle2: '确定下架吗？',
  confirmTitle3: '确定批量下架吗？',
  confirmTitle4: '确定批量再报吗？',
  okText: '确定',
  cancelText: '取消'
}
